import { useMemo } from "react";

import { SURVEY_PARTICIPANTS_CONFIG, type ViewType } from "../constants";

export const useViewSelector = (
	surveyAccess: string | null | undefined,
	editParticipants: boolean,
	surveyStatus: string
): ViewType => {
	return useMemo(() => {
		if (!surveyAccess || surveyAccess === SURVEY_PARTICIPANTS_CONFIG.SURVEY_ACCESS.ALL_EMPLOYEES) {
			return SURVEY_PARTICIPANTS_CONFIG.VIEW_TYPES.ALL_EMPLOYEES;
		}
		if (editParticipants && surveyStatus !== "closed") {
			return SURVEY_PARTICIPANTS_CONFIG.VIEW_TYPES.SELECT_PARTICIPANTS;
		}
		return SURVEY_PARTICIPANTS_CONFIG.VIEW_TYPES.PARTICIPANTS;
	}, [surveyAccess, editParticipants, surveyStatus]);
};
